import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-consult-accident',
  templateUrl: './consult-accident.component.html',
  styleUrls: ['./consult-accident.component.scss']
})
export class ConsultAccidentComponent implements OnInit {
  filter
  dateDeb
  dateFin
  dateDebD
  dateFinF
  listAccident
  constructor(private generalService: GeneralService, private datePipe: DatePipe) {
   }
  validDate() {
    let test = true
    if (!this.dateFin && !this.dateDebD) {
      test = false
    }
    return test
  }
  ngOnInit(): void {
  }
  filtrer() {
    if (this.validDate()) {
      this.generalService.rechercheTable2('API_ListeAccidents', this.dateDebD + ',' + this.dateFinF).subscribe(res => {
        console.log(res);
        this.listAccident = res
        this.listAccident.forEach(element => {
          this.getVictimeName(element.Perso_Matricule).then(res=>{
            element.Perso_Name=res
          })
          this.getEmployeurName(element.Id_Employeur).then(res=>{
            element.Employeur_Name=res
          })
        });
      })
    }
    else {
      this.generalService.dialogSuccess(
        'Choisir les date',
        false
      );
    }
  }
  rowClick(event)
  {
    console.log(event);
  }
  dateFinChange() {
    this.dateFinF = this.datePipe.transform(this.dateFin, 'MM/dd/YYYY')
  }
  dateDebChange() {
    this.dateDebD = this.datePipe.transform(this.dateDeb, 'MM/dd/YYYY')
  }
  async getVictimeName(id)
  {
    let promise = await (this.generalService.getDS('avtPerso',id)).toPromise()
    var userName =promise["perso"][0].Perso_Prenom +' '+ promise["perso"][0].Perso_Nom
    //console.log(userName);
    return userName;
  }
  async getEmployeurName(id)
  {
    let promise = await (this.generalService.getDS('SOC',id)).toPromise()
    var socName =promise["SOC"][0].SOC_RS 
    //console.log(socName);
    return socName;
  }

}
